import clsx from "clsx";
import _ from "lodash";
import Table from "react-bootstrap/Table";
import * as setOffSelectors from "../../../../selectors/set-off";
import React, { Fragment } from "react";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import EmptyItemView from "../../../../components/EmptyItemView";
import {
  getSetOffMetaDataIscancellable,
  getSetOffTransactionDateTimeText,
  getSubmittedContractCurrencyCodeSymbol,
  getSubmittedContractType, getSubmittedNumberOfUnits
} from "../../../../selectors/set-off";

function ActionCustomTable({
  type,
  data,
  onClickViewDetail,
  onClickDelete,
  loading,
  isDeleteLoading = false,
  isPayment = false,
}) {
  return (
    <div
      className={clsx(
        "custom-table-info-container position-relative mt-3 mb-5",
      )}
    >
      <Table responsive="md">
        <thead>
          <tr className={"custom-table-e-setoff-submitted"}>
            <th style={{ minWidth: 160, maxWidth: 160 }}>Date/Time</th>
            <th style={{ minWidth: 120, maxWidth: 120 }}>
              {type === "setoff" || type === "withdraw"
                ? "Client Code"
                : type === "ipo"
                  ? "Number of Units"
                  : "Type"}
            </th>
            <th style={{ minWidth: 140, maxWidth: 140 }}>Currency Code</th>
            <th style={{ minWidth: 160, maxWidth: 160 }}>Status</th>
            <th style={{ minWidth: 180, maxWidth: 180 }}>Transaction Amount</th>
            <th style={{ minWidth: 120, maxWidth: 120 }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {!_.isEmpty(data) ? (
            _.map(data, (submittedContract, key) => {
              const isCancellable =
                setOffSelectors.getSetOffMetaDataIscancellable(
                  submittedContract,
                );
              const cancelLink =
                setOffSelectors.getSetOffMetaDataCancelLink(submittedContract);
              const clientCode =
                setOffSelectors.getSubmittedContractClientCode(
                  submittedContract,
                );
              const currencyCode =
                setOffSelectors.getSubmittedContractCurrencyCodeSymbol(
                  submittedContract,
                );
              const transactionDateTimeText =
                setOffSelectors.getSetOffTransactionDateTimeText(
                  submittedContract,
                );
              const status =
                setOffSelectors.getSubmittedContractStatusText(
                  submittedContract,
                );
              const contractType =
                setOffSelectors.getSubmittedContractType(submittedContract);
              const transactionAmountOff =
                setOffSelectors.getSubmittedContractTransactionAmountFullText(
                  submittedContract,
                );
              const numberOfUnits =
                setOffSelectors.getSubmittedNumberOfUnits(submittedContract);
              const dynamicValue = type === 'ipo' ? numberOfUnits: contractType || clientCode
              return (
                <Fragment key={key}>
                  <tr key={key}>
                    <td style={{ minWidth: 160, maxWidth: 160 }}>
                      {transactionDateTimeText}
                    </td>
                    <td style={{ minWidth: 120, maxWidth: 120 }}>
                      {dynamicValue}
                    </td>
                    <td style={{ minWidth: 140, maxWidth: 140 }}>
                      {currencyCode}
                    </td>
                    <td style={{ minWidth: 160, maxWidth: 160 }}>{status}</td>
                    <td style={{ minWidth: 180, maxWidth: 180 }}>
                      {transactionAmountOff}
                    </td>
                    <td style={{ minWidth: 120, maxWidth: 120 }}>
                      <div className={clsx("d-flex flex-row")}>
                        <button
                          className={clsx(
                            "btn custom-button-fill-primary small long",
                          )}
                          onClick={(e) => {
                            e.preventDefault();
                            if (type === "ipo") {
                              onClickViewDetail(
                                _.get(submittedContract, ["id"]),
                              );
                              return;
                            }
                            onClickViewDetail(submittedContract, isPayment);
                          }}
                          // disabled={!isCancellable}
                        >
                          View
                        </button>
                        {isCancellable ? (
                          <button
                            className={clsx(
                              "btn custom-button-white small long mx-2",
                            )}
                            onClick={(e) => {
                              e.preventDefault();
                              onClickDelete(cancelLink, type);
                            }}
                            disabled={!isCancellable}
                          >
                            Cancel
                          </button>
                        ) : (
                          false
                        )}
                      </div>
                    </td>
                    {/*<td>*/}

                    {/*</td>*/}
                  </tr>
                </Fragment>
              );
            })
          ) : (
            <tr>
              <td colSpan={6}>
                <EmptyItemView />
                <LoadingOverlay
                  loading={loading || isDeleteLoading}
                ></LoadingOverlay>
              </td>
            </tr>
          )}
          <LoadingOverlay loading={isDeleteLoading}></LoadingOverlay>
        </tbody>
      </Table>
    </div>
  );
}

export default ActionCustomTable;
